import Analytics from '@opencare/analytics';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectDataUserAuthenticated } from 'connect/selectors';
import { StepFormWrapper, StepHeader, StepHeaderSubtext, StepHeaderText, StepWrapper } from 'pages/checkout/components/common/layout-styled-components';
import { useCheckoutRedesignAnalyticsData } from 'pages/checkout/utils/analyticsUtils';

import { AppointmentDetails } from './components/AppointmentDetails/AppointmentDetails';
import { LoggedIn } from './components/LoggedIn/LoggedIn';
import { LoginForm } from './components/LoginForm';
import { SignupForm } from './components/SignupForm';

const analytics = new Analytics();

enum FormState {
  SIGNUP,
  LOGIN,
  LOGGED_IN,
}

const renderForm = (formState: FormState, props: any) => {
  const componentToRender = {
    [FormState.SIGNUP]: <SignupForm {...props} />,
    [FormState.LOGIN]: <LoginForm {...props} />,
    [FormState.LOGGED_IN]: <LoggedIn {...props} />,
  }[formState];

  return componentToRender;
};

const HeaderTexts = {
  [FormState.SIGNUP]: 'Book your appointment',
  [FormState.LOGIN]: 'Log in to book your appointment',
  [FormState.LOGGED_IN]: 'Book your appointment',
};

export const Info = () => {
  const [formState, setFormState] = useState<FormState>(FormState.SIGNUP);
  const analyticsData = useCheckoutRedesignAnalyticsData();

  const headerText = useMemo(() => HeaderTexts[formState], [formState]);

  const setLogIn = () => setFormState(FormState.LOGIN);
  const setSignUp = () => setFormState(FormState.SIGNUP);

  const isUserAuthenticated = useSelector(selectDataUserAuthenticated);

  useEffect(() => {
    analytics.trackPageView({
      pageType: analytics.pageTypes.CHECKOUT,
      pageName: 'checkout-info',
      name: 'checkout',
      section: 'account-info',
      ...analyticsData,
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps -- analyticsData is a new object every time, so we don't want it in the dependency array
  }, []);

  useEffect(() => {
    if (!isUserAuthenticated) {
      return;
    }

    // Push setting state action to end of event loop so the forms can handle auth success
    const timeout = setTimeout(() => {
      setFormState(FormState.LOGGED_IN);
    });

    return () => clearTimeout(timeout);
  }, [isUserAuthenticated]);

  return (
    <StepWrapper>
      <StepFormWrapper>
        <StepHeader>
          <StepHeaderText>{headerText}</StepHeaderText>
          <StepHeaderSubtext>We will keep your information safe and secure.</StepHeaderSubtext>
        </StepHeader>

        <AppointmentDetails />

        {renderForm(formState, { setLogIn, setSignUp })}
      </StepFormWrapper>
    </StepWrapper>
  );
};
